import {
  EPData,
  EPTranscript,
  HarmonyIcon,
  MarkerIcon,
  TrainIcon,
} from '@rsos/assets/icons';
import { Checkbox } from './ShareEvent.types';

/**
 * Canonical data-source ids — the single source of truth shared by the
 * checkbox definitions below and the payload builders in FieldShare/helpers,
 * so a rename can't silently desync the checkbox from what gets sent.
 */
export const DATA_SOURCE_IDS = {
  INCIDENT_LOCATION: 'incident_location',
  ADDITIONAL_DATA: 'additional_data',
  CALL_SUMMARY: 'call_summary',
  CALL_TRANSCRIPT: 'call_transcript',
  RESOURCE_REQUEST: 'resource_request',
} as const;

const dataSources: Checkbox[] = [
  {
    label: 'Location',
    description: 'Current and location history',
    disabled: false,
    isChecked: false,
    id: DATA_SOURCE_IDS.INCIDENT_LOCATION,
    icon: MarkerIcon,
  },
  {
    label: 'Caller Data',
    description: 'Caller additional data request(ADR)',
    disabled: false,
    isChecked: false,
    id: DATA_SOURCE_IDS.ADDITIONAL_DATA,
    icon: EPData,
  },
  {
    label: 'Call Summary',
    description: 'AI-generated summary of the call',
    disabled: false,
    isChecked: false,
    id: DATA_SOURCE_IDS.CALL_SUMMARY,
    icon: HarmonyIcon,
  },
  {
    label: 'Call Transcript',
    description: 'Live transcript of the call',
    disabled: false,
    isChecked: false,
    id: DATA_SOURCE_IDS.CALL_TRANSCRIPT,
    icon: EPTranscript,
  },
];

export const resourceRequestDataSources: Checkbox[] = [
  {
    label: 'Train Consist',
    description: 'Train details and every car, including hazmat',
    disabled: false,
    isChecked: false,
    id: DATA_SOURCE_IDS.RESOURCE_REQUEST,
    icon: TrainIcon,
  },
];

export default dataSources;
